var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navigation",class:_vm.orientation},_vm._l((_vm.items),function(item){return _c('li',{key:item.name},[_c('BaseAction',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var actionAttrs = ref.actionAttrs;
var handleClick = ref.handleClick;
return [_c('a',_vm._b({on:{"click":handleClick}},'a',actionAttrs,false),[_vm._v(" "+_vm._s(item.title)+" ")])]}}],null,true)},'BaseAction',item.action,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }